export default __webpack_public_path__ + "static/media/relacionamento_virtual.06ce2b6e.svg";